<script>
export let url = ""
export let seconds = ""

if (url) {
  setTimeout(function () {
    window.location.href = url
  }, seconds)
}
</script>